import api from '../services/api';
import getHeaders from '../utils/returnHeaders';

// US-17: categorias disponiveis na campanha ativa (navegador inicial do buscador).
// A campanha e resolvida pelo backend a partir do token (sessao), nao precisa enviar.
const getExperienceCategories = async () => {
  const header = getHeaders();
  return api.get('/experience/categories', header);
};

export { getExperienceCategories };
